import { Component } from '@angular/core';
import { ThemeConstantService } from '../../services/theme-constant.service';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../services/authentication.service';
import { BehaviorSubject } from 'rxjs';
import { User } from '../../models/user';
import { JwtHelperService } from '@auth0/angular-jwt';
import { MsalService } from '@azure/msal-angular';
@Component({
  selector: 'app-full-header',
  templateUrl: './full-header.component.html',
  styleUrls: ['./full-header.component.css']
})
export class FullHeaderComponent {

 
  searchVisible : boolean = false;
  quickViewVisible : boolean = false;
  isFolded : boolean;
  isExpand : boolean;
  public UserData: any;
  UserStatus:boolean;
  private userSubject: BehaviorSubject<User>;

  constructor( private themeService: ThemeConstantService, public router: Router,  private authenticationService: AuthenticationService, public jwtHelper: JwtHelperService,
    public msalService: MsalService) {

  }

  ngOnInit(): void {
    this.UserData = this.authenticationService.userValue;
      this.themeService.isMenuFoldedChanges.subscribe(isFolded => this.isFolded = isFolded);
      this.themeService.isExpandChanges.subscribe(isExpand => this.isExpand = isExpand);
      let ssoToken = this.authenticationService.GetAccessToken();
      this.UserData = this.jwtHelper.decodeToken(localStorage.getItem('accessToken'));
      this.UserStatus =  this.authenticationService.loginDisplay;
  
  }
  toggleFold() {
      this.isFolded = !this.isFolded;
      this.themeService.toggleFold(this.isFolded);
  }

  toggleExpand() {
      this.isFolded = false;
      this.isExpand = !this.isExpand;
      this.themeService.toggleExpand(this.isExpand);
      this.themeService.toggleFold(this.isFolded);
  }

  searchToggle(): void {
      this.searchVisible = !this.searchVisible;
  }

  quickViewToggle(): void {
      this.quickViewVisible = !this.quickViewVisible;
  }

  sessionClear() {
    this.authenticationService.logout();
   localStorage.clear();


  }

  logout(){
    localStorage.clear();
    this.authenticationService.logout();
  }
}
